import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17 16.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "12",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "13",
  cy: "8",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "13",
  cy: "16",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 12.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "13",
  cy: "12",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v2H3z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "8",
  r: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "12",
  r: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "5",
  cy: "16",
  r: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 8.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "16",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18v2H3z"
})), 'BlurLinearTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BlurLinearTwoTone.js
// module id = 2377
// module chunks = 2